import styled from 'styled-components';

export const DivPreview = styled.div`
  /* width: 100%; */
  /* height: 100%; */
  /* position: relative; */
  text-align: center;
`;

export const ImgPreview = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 0.1rem;
`;

export const WrapperDiv = styled.div`
  height: 100%;
  width: 100%;
  padding: 2rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: var(--color-background);
  text-align: center;
`;

export const ImgDiv = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Img = styled.img`
  width: 100%;
`;

export const BackgroundContainer = styled.div`
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 0.2rem;
  background-color: black;
  box-sizing: border-box;  
  `;

export const ButtonsContainer = styled.div`
  margin-top:20rem;
  position:absolute;
  width: 100%;
  height: 5rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
`;

export const CameraContainer = styled.div`
position: relative;
width: 100%;
height: 100%;
padding: 0,1rem;
border-radius: 20px;
`;